import { ForgeProjectSection } from "./SDKForgeProjectSection";
export class ForgeProjectArtifactSection extends ForgeProjectSection {
    constructor(model) {
        super(model);
        this.childType = "Artifact";
    }
}
